import { NextPageContext } from 'next/dist/shared/lib/utils'
import { isBrowser } from '../helpers/core'

const getDomainByHost = (host: string): string | null => {
  if (host) {
    return host.split('.')[0]
  }

  return null
}

/* проверяем домен */
export const domainComparison = (ctx: NextPageContext, domain: string): boolean => {
  const { req } = ctx
  const host = isBrowser ? window.location.host : req?.headers.host || ''
  const reqDomain = getDomainByHost(host)

  return domain === reqDomain
}
